import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import { useLayoutEffect, useRef, useState } from "react";

import { getWindow } from "src/utility/window";

const NonprofitAdminRoutesRegex = /^\/[^/]+\/admin(\/.*)?$/;

export function usePageTransition(): boolean {
  const router = useRouter();
  const pathname = usePathname();
  const prevPathRef = useRef(pathname);

  const [pageTransition, setPageTransition] = useState(false);

  useLayoutEffect(() => {
    const window = getWindow();

    if (!window) {
      return;
    }

    const handleStart = (url: string) => {
      const nextUrl = new URL(url, window.location.origin);
      const nextPath = nextUrl.pathname;

      if (
        NonprofitAdminRoutesRegex.test(nextPath) &&
        NonprofitAdminRoutesRegex.test(prevPathRef.current)
      ) {
        return;
      }

      if (nextPath !== prevPathRef.current) {
        setPageTransition(true);
      }
    };

    const handleComplete = () => {
      prevPathRef.current = pathname;
      setPageTransition(false);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [pathname, router.events]);

  return pageTransition;
}
